import React from 'react';
import { motion } from 'framer-motion';

type JourneyKeyProps = {
  turned?: boolean;
  interactive?: boolean;
  onClick?: () => void;
  className?: string;
};

const JourneyKey: React.FC<JourneyKeyProps> = ({
  turned = false,
  interactive = false,
  onClick,
  className = '',
}) => {
  return (
    <motion.div
      className={`absolute z-20 ${interactive ? 'cursor-pointer' : 'pointer-events-none'} ${className}`}
      style={{ width: '19%', aspectRatio: '72 / 180' }}
      initial={false}
      animate={turned ? { left: ['-24%', '47.25%', '47.25%', '47.25%', '35.25%'], top: ['36%', '-18%', '-18%', '-26%', '-26%'] } : { left: '-24%', top: '36%' }}
      transition={{ duration: 3.6, times: [0, 0.28, 0.82, 0.9, 1], ease: 'easeInOut' }}
      onClick={interactive ? onClick : undefined}
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      onKeyDown={interactive ? (e) => (e.key === 'Enter' || e.key === ' ') && onClick?.() : undefined}
      aria-label={interactive ? (turned ? 'Bottle unlocked' : 'Click to turn key and unlock bottle') : 'RightOZ consumer bottle key'}
    >
      <motion.div
        className="h-full w-full"
        style={{ transformOrigin: '83% 86%', transformPerspective: 640 }}
        initial={false}
        animate={{
          rotateY: turned ? [0, 0, -45, -45] : 0,
          scale: interactive && !turned ? [1, 1.06, 1] : 1,
        }}
        transition={{
          rotateY: turned ? { duration: 3.6, times: [0, 0.28, 0.46, 1], ease: 'easeInOut' } : { duration: 0.25 },
          scale: { duration: 2, repeat: interactive && !turned ? Infinity : 0, repeatDelay: 0.8 },
        }}
      >
        <svg
          viewBox="0 0 72 180"
          className="h-full w-full overflow-visible drop-shadow-[0_8px_12px_rgba(0,0,0,0.35)]"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="keySteel" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#eef2f0" />
              <stop offset="45%" stopColor="#a9b2ae" />
              <stop offset="72%" stopColor="#e5e9e7" />
              <stop offset="100%" stopColor="#69736f" />
            </linearGradient>
          </defs>

          <g transform="rotate(16 60 150)">
            {/* Complete key moves tip-first into the top lock. */}
            <path d="M34 44 L61 139 L50 143 L23 48 Z" fill="url(#keySteel)" stroke="#414a47" strokeWidth="3" strokeLinejoin="round" />
            <path d="M50 113 L65 109 L69 122 L55 126 Z M55 130 L69 126 L72 139 L59 143 Z M49 141 L64 137 L68 151 L53 155 Z" fill="#7f8985" stroke="#414a47" strokeWidth="2.5" strokeLinejoin="round" />
            <path d="M31 50 L56 136" stroke="#f6f8f7" strokeWidth="2.5" strokeLinecap="round" opacity="0.68" />
            <path fillRule="evenodd" d="M28 2a24 24 0 1 1 0 48 24 24 0 0 1 0-48Zm0 12a12 12 0 1 0 0 24 12 12 0 0 0 0-24Z" fill="url(#keySteel)" stroke="#414a47" strokeWidth="3" />
            <circle cx="28" cy="26" r="12" stroke="#69736f" strokeWidth="2.5" />
          </g>
        </svg>
      </motion.div>
    </motion.div>
  );
};

export default JourneyKey;
